// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__N5htH","bigColWidth":"Table_bigColWidth__1L-9_","biggerColWidth":"Table_biggerColWidth__1TL8s","row":"Table_row__2CsNz","col":"Table_col__1yBTA"};